(ns iris.posts.views.company-panel
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [iris.events :as events]
   [iris.posts.events :as posts-events]
   [iris.posts.subs :as posts-subs]
   [clojure.string :as string]
   [iris.posts.common :refer [agor-edit-url]]))

(defn on-click-delete-og-image [e ruid]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-header-delete-og-image-flow ruid]))


(defn og-image [ruid og_image_url]
  (let [delete-atom (reagent/atom false)]
    (fn []
      [:div
       {:style {:width "150px" :height "100px" :float "right"}}
       "OG image:"
       [:img
        {:src og_image_url
         :class "img-responsive"
         :style {:border "1px solid LightGrey"}}]
       (cond (false? @delete-atom)
             [:a {:on-click #(reset! delete-atom true)}
              "delete"
              [:i {:class "glyphicon glyphicon-remove"}]]
             (true? @delete-atom)
             [:<>
              [:div "Please confirm delete:"]
              [:a {:on-click (fn [e] (on-click-delete-og-image e ruid))
                   :style {:color "red"}}
               "delete"
               [:i {:class "glyphicon glyphicon-remove"}]]
              " | "
              [:a {:on-click #(reset! delete-atom false)}
               "cancel"]])])))



(defn on-click-render [e ruid]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-render-header-flow ruid]))


;; 6/18/2025 update:
;; This used to help with ws redirect and back button issue but is not needed anymore. 
;; Added history replace state inside iris>views>default-ws-redirect which will take care of it 
;; (defn on-click-header-html [e header]
;;   (.preventDefault e)
;;   ;; stops event propagation and link from executing
;;   (.stopPropagation e)
;;   ;; add ws to related company href...
;;   (when (= (.-tagName (.-target e)) "A")
;;   ;;  ...when test target is a link...
;;     (when-let [nick (some #(and (clojure.string/ends-with? (.-href (.-target e)) %) %) (:rels_nicks header))]
;;     ;; ...and target href url ends with one of the items from (:rels_nicks header) vector
;;     ;; note: "some" returns the element the caused it to return true - explanation:
;;     ;; https://clojuredocs.org/clojure.core/some#example-56398c8fe4b0290a56055d1b
;;       (re-frame/dispatch [::events/route-to (str nick "." (:ws header))]))))


(defn company-panel []
  (let [header @(re-frame/subscribe [::posts-subs/header])]
    [:div#company.panel.panel-default
     [:div.panel-heading [:h2 (:title header)]]
     [:div#companyinfo.panel-body
      (when (true? (:has_og_image header))
        [og-image (:ruid header) (:og_image_url header)])
      [:div {
            ;;  :on-click (fn [e] (on-click-header-html e header))
             :dangerouslySetInnerHTML
            ;;  {:__html
              (reagent/unsafe-html (:html header))
              ;; }
             }]]
      ;; (when (true? (:has_og_image header))
      ;;   [og-image (:ruid header) (:og_image_url header)])
      ;; [:p "Company information:"]
      ;; [:dl.header-profile
      ;;  [:dt "Industry/Area of Activity:"]
      ;;  [:dd (:category header)]
      ;;  [:dt "Company Stock Ticker:"]
      ;;  [:dd (:symbol header)]
      ;;  [:dt "Stock traded at:"]
      ;;  [:dd (:exchange header)]
      ;;  [:dt "Industry Code:"]
      ;;  [:dd (:industry_code header)]
      ;;  [:dt "About Wells Fargo & Co.:"]
      ;;  [:dd (:descr header)]
      ;;  [:dt "Revenue information:"]
      ;;  [:dd (:revenue_info header)]
      ;;  [:dt "Contact information:"]
      ;;  [:dd (:contact_info header)]
      ;;  [:dt "More information:"]
      ;;  [:dd (:custom_html header)]
      ;;  [:dt "Related companies:"]
      ;;  [:dd
      ;;   ;; NOTE: we are missing company titles
      ;;   (for [[index d] (map-indexed vector (:rels_nicks header))]
      ;;     [:<>
      ;;      [:a {:href (str d "." (:ws header))} (subs d 1)]
      ;;      (when (< (+ index 1) (count (:rels_nicks header)))
      ;;        " | ")])]]

     [:div.panel-footer
      [:span
       "Last modified"
       [:time
        {:dateTime (:updated_iso header) :itemProp "datePublished"}]
       (str " by " (or (get-in header [:meta :updated_by])
                       (get-in header [:meta :created_by])))]
      " | "
      [:a
       {:href   (agor-edit-url (:ruid header) (:genus header) (:ws header) (:title header))
        :target "_blank"}
       "Edit Header "
       [:i.glyphicon.glyphicon-edit]]
      " | "
      [:a
       {:on-click (fn [e] (on-click-render e (:ruid header)))}
       "Render "
       [:i.glyphicon.glyphicon-file]]]]))
